import { render, staticRenderFns } from "./HoldStartButton.vue?vue&type=template&id=356e3064"
import script from "./HoldStartButton.vue?vue&type=script&lang=js"
export * from "./HoldStartButton.vue?vue&type=script&lang=js"
import style0 from "./HoldStartButton.vue?vue&type=style&index=0&id=356e3064&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports